import type { ApiRequest } from '@zurich-framework/core/api';

type GetGenericDocumentParams = { documentId: string; fileId: string };

export const getVSGAPhoto: ApiRequest<void, GetGenericDocumentParams, false> = {
  source: 'app',
  route: '/document',
  method: 'GET',
};
